export default class Room {
    public availabilities!: any[];
    public bookings!: any[];
    public createdAt!: Date;
    public id!: string;
    public inventory!: any[];
    public quantity!: number;
    public title!: string;
    public updatedAt!: Date;
    public prices!: any[];
    public pricingEnabled!: boolean;
    public currencyCode!: string;
    public sellable!: string;
}
